import React from "react";

const LandingPageFooter = () => {
  const styles = {
    footer: {
      backgroundColor: "#333333",
      color: "#a0a0a0",
      padding: "20px 0",
      fontFamily: "Arial, sans-serif",
      fontSize: "14px",
    },
    container: {
      width: "90%",
      maxWidth: "1200px",
      margin: "0 auto",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    logo: {
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
      width: "100%",
    },
    logoText: {
      color: "white",
      fontSize: "20px",
      fontWeight: "bold",
      marginLeft: "10px",
    },
    colorsBar: {
      display: "flex",
      marginRight: "10px",
    },
    colorBlock: {
      width: "8px",
      height: "20px",
      display: "inline-block",
    },
    red: {
      backgroundColor: "red",
    },
    yellow: {
      backgroundColor: "yellow",
    },
    green: {
      backgroundColor: "lime",
    },
    column: {
      margin: "0 20px 20px 0",
      flex: "1",
      minWidth: "200px",
    },
    link: {
      color: "#a0a0a0",
      textDecoration: "none",
      display: "block",
      marginBottom: "8px",
      transition: "color 0.2s ease",
    },
    copyright: {
      color: "#a0a0a0",
    },
  };

  const Column1Links = [
    { text: "© 2025 Qbank360 Ltd", href: "#" },
    // { text: "Terms and conditions", href: "#" },
    // { text: "Privacy policy", href: "#" },
  ];

  const Column2Links = [
    { text: "Qbank360 Ltd", href: "#" },
    { text: "71-75 Shelton Street", href: "#" },
    { text: "Covent Garden", href: "#" },
    { text: "London", href: "#" },
    { text: "WC2H 9JQ", href: "#" },
  ];

  const Column3Links = [
    { text: "Contact us", href: "/contactpage" },
    { text: "Work with us", href: "/workwithuspage" },
  ];

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.logo}>
          <div style={styles.colorsBar}>
            <span style={{ ...styles.colorBlock, ...styles.red }}></span>
            <span style={{ ...styles.colorBlock, ...styles.yellow }}></span>
            <span style={{ ...styles.colorBlock, ...styles.green }}></span>
          </div>
          <span style={styles.logoText}>Qbank360</span>
        </div>

        <div style={styles.column}>
          {Column1Links.map((link, index) => (
            <a key={index} href={link.href} style={styles.link}>
              {link.text}
            </a>
          ))}
        </div>

        <div style={styles.column}>
          {Column2Links.map((link, index) => (
            <a key={index} href={link.href} style={styles.link}>
              {link.text}
            </a>
          ))}
        </div>

        <div style={styles.column}>
          {Column3Links.map((link, index) => (
            <a key={index} href={link.href} style={styles.link}>
              {link.text}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;
